var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBackButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 612 612",
    style: {
      enableBackground: "new 0 0 612 612"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "_x34__7_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M439.875,286.875H237.418l78.813-78.814c7.479-7.478,7.479-19.584,0-27.043c-7.478-7.478-19.583-7.478-27.042,0 l-108.19,108.19c-4.571,4.571-6.005,10.863-4.954,16.792c-1.052,5.929,0.383,12.221,4.973,16.811l108.19,108.19 c7.478,7.478,19.584,7.478,27.043,0c7.478-7.478,7.478-19.584,0-27.043l-78.833-78.833h202.457 c10.557,0,19.125-8.568,19.125-19.125C459,295.443,450.432,286.875,439.875,286.875z M306,0C136.992,0,0,136.992,0,306 c0,168.988,136.992,306,306,306s306-137.012,306-306C612,136.992,475.008,0,306,0z M306,573.75 C158.125,573.75,38.25,453.875,38.25,306C38.25,158.125,158.125,38.25,306,38.25c147.875,0,267.75,119.875,267.75,267.75 C573.75,453.875,453.875,573.75,306,573.75z"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackButton);
export default __webpack_public_path__ + "static/media/backButton.f21ad9566e54ea8c84359e4990c3b998.svg";
export { ForwardRef as ReactComponent };